export function getCategoryColor(category) {
    switch (category) {
        case 0: // Sem categoria
            return "#E5E7EB"; // Cinza claro

        case 1: // HEALTH_STATUS
            return "#22C55E"; // Verde

        case 2: // CRITICAL_ALARMS
            return "#EF4444"; // Vermelho

        case 3: // MAJOR_ALARMS
            return "#F59E0B"; // Laranja/Âmbar

        case 4: // OPERATIONAL_DATA
            return "#3B82F6"; // Azul

        case 5: // GENERAL_INFORMATION
            return "#967ADD"; // Roxo

        default:
            return null;
    }
}